import { useSelector } from 'react-redux';
import { RootState } from 'data';

export const useProfile = () => {
//   const user = useSelector((state: RootState) => state.auth.user);
  const profileState = useSelector((state: RootState) => state.profile);
  const documentsState = useSelector((state: RootState) => state.document);

  const user = localStorage.getItem('user');
  const userObj = user ? JSON.parse(user) : null;

  return {
    id: userObj.id,
    email: profileState.profile?.email,
    role: userObj.role,
    firstName: profileState.profile?.firstName || '',
    lastName: profileState.profile?.lastName || '',
    middleName: profileState.profile?.middleName || '',
    language: profileState.profile?.language || '',
    phone: profileState.profile?.phone || '',
    addresses: profileState.address ? [profileState.address] : [],
    bankingInfo: profileState.bankingInfo ? [profileState.bankingInfo] : [],
    personalInfo: profileState.personalInfo || null,
    avatar: documentsState.avatar,
    childCertificate: documentsState.childCertificate,
    idCard: documentsState.idCard,
  };
};
